import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import * as moment from "moment";
import _ from 'lodash';
import { Chart } from 'chart.js';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-patient-status',
  templateUrl: 'program-patient-status.html',
})
export class ProgramPatientStatusPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  status_counts: any[] = [];
  status_name: any[] = [];
  status_chart: any[] = [];
  substatus_chart: any[] = [];
  statuses: any[] = [];
  substatus_counts: any[] = [];
  substatus_name: any[] = [];
  patients: any[] = [];

  status = 'Pending Enrolment';

  constructor(    
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      
      this.database
      .getAdminSettings(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((settings) => {
        // console.log('Settings: ', settings);
        this.statuses = settings[0]['statuses'];
        // console.log('Task Types: ', this.statuses);

        this.database
      .getPatientsByProgramMTD(this.program_id, moment().format('YYYY'), moment().format('MM'))
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((patients) => {
        this.patients = patients;
        this.status_counts = [];
        this.status_name = [];
        this.statuses.forEach(statuses => {
          const count = patients.filter((obj) => obj.status === statuses.status).length
          this.status_counts.push(count);
          this.status_name.push(statuses.status);
        });
        setTimeout(() => {
          this.status_chart = new Chart('status_chart', {
            type: 'horizontalBar',
            data: {
              labels: this.status_name,
              datasets: [
                {
                  data: this.status_counts,
                  backgroundColor: ["red", "blue", "green", "orange", "pink", "brown", "yellow", "indigo", "grey"],
                  fill: true
                }
              ]
            },
            options: {
              title: {
                display: true,
                text: 'Current Patient Status'
              },
              legend: {
                display: false,
                position: 'bottom'
              },
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: 'Status'
                },
                ticks: {
                  beginAtZero: true,
                  max: 20
              }
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Status'
                },
                  ticks: {
                    beginAtZero: true,
                    max: 20
                }
                }],
              }
            }
          });
        },100)
        this.statusChange(this.status);
      });
      });

      

      
      
    });
  }

  ngOnDestroy() {
  console.log('Leave program patient status view and destroy subscriptions');
  this.ngUnsubscribe.next();
  this.ngUnsubscribe.complete();
  }

  statusChange(ev)  {
    // console.log(ev);
      const status = this.statuses.filter((obj) => obj.status === ev);
      // console.log('Status: ', status);
      const substatuses = status[0].substatus
      // console.log('Substatus: ', substatuses);
      this.substatus_counts = [];
      this.substatus_name = [];
      substatuses.forEach(substatus => {
        // console.log('Substatus: ', substatus);
        const count = this.patients.filter((obj) => obj.substatus === substatus).length
        this.substatus_counts.push(count);
        this.substatus_name.push(substatus);
      });
      setTimeout(() => {
        this.substatus_chart = new Chart('substatus_chart', {
          type: 'horizontalBar',
          data: {
            labels: this.substatus_name,
            datasets: [
              {
                data: this.substatus_counts,
                backgroundColor: ["red", "blue", "green", "orange", "pink", "brown", "yellow", "indigo", "grey"],
                fill: true
              }
            ]
          },
          options: {
            title: {
              display: true,
              text: 'Current Patient Substatus'
            },
            legend: {
              display: false,
              position: 'bottom'
            },
            scales: {
              xAxes: [{
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: 'Substatus'
              },
              ticks: {
                beginAtZero: true,
                max: 20
            }
              }],
              yAxes: [{
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: 'Status'
              },
                ticks: {
                  beginAtZero: true,
                  max: 20
              }
              }],
            }
          }
        });
      },100)

  }

  ionViewDidLoad() {
   
  }
}



// WEBPACK FOOTER //
// ./src/pages/program-patient-status/program-patient-status.ts